import { Box } from "@chakra-ui/react";
import { Navigate } from "react-router-dom";
import { Navbar } from "../components/landing/Navbar";
import { Footer } from "../components/landing/Footer";
import { Investment } from "../components/funds/Investment";
import { useAuth } from "../context/AuthContext";
import { ROUTE_PATHS } from "../config/routes";

export const InvestmentPage = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to={ROUTE_PATHS.LOGIN} replace />;
  }

  return (
    <Box dir="rtl" overflowX="hidden">
      <Navbar />
      <Investment />
      <Footer />
    </Box>
  );
};
